import React from 'react';

var ZoomOut = function ZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.358 15.809a7.692 7.692 0 1 1 1.45-1.45l5.892 5.89a1.026 1.026 0 0 1-1.45 1.45l-5.892-5.89zm-4.666-.476a5.641 5.641 0 1 0 0-11.282 5.641 5.641 0 0 0 0 11.282zm-2.564-4.615h5.128a1.026 1.026 0 1 0 0-2.051H7.128a1.026 1.026 0 1 0 0 2.05z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ZoomOut.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ZoomOut as icon };
export default iconHandler(ZoomOut);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ZoomOut.js
// module id = 633
// module chunks = 0